import React, { useContext, useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { useLocation, useParams } from 'react-router-dom';
import AccionaTableDelivery from './components/AccionaTableDelivery';
import AccionaTableLaboratory from './components/AccionaTableLaboratory';
import { MainContext } from '../../../../../context/MainContext';
import { getFile } from '../../../../../services/api/files';
import {
  getScannedDocument,
  getScannedDocumentByMysqlID,
} from '../../../../../services/api/scannedDocuments';
import ViewImage from '../../../../../components/ViewImage';

const DataDoc = () => {
  const { setLoading, project, setError } = useContext(MainContext);
  const { model, sdId, mysqlId, fileName } = useParams();
  const [initialData, setInitialData] = useState(null);
  const [selectedImg, setSelectedImg] = useState(false);
  const [camFileName, setCamFileName] = useState(null);

  const [selectedCamImage, setCamImage] = useState(null);
  const pidstring = useLocation().search;

  const paramsUrl = {
    model,
    sdId,
    mysqlId,
    fileName,
    pidstring,
  };

  useEffect(() => {
    async function loadTemplate() {
      setLoading(true);
      if (model === 'delivery') {
        const scannedDoc = (await getScannedDocument(sdId)).data;
        const loadedDeliveryNote = scannedDoc.delivery_note_data;
        setInitialData(loadedDeliveryNote);
        setCamFileName(scannedDoc.camFileName);
      } else {
        const scannedDoc = (await getScannedDocument(sdId)).data;
        const laboratoryNote = scannedDoc.laboratory_note_data;
        const laboratory = laboratoryNote.laboratory_data;
        const deliveryNote = laboratoryNote.delivery_note_data;
        const deliveryNoteSD = (
          await getScannedDocumentByMysqlID(deliveryNote.id)
        ).data;
        setCamFileName(deliveryNoteSD.data[0].fileName);
        setInitialData({ ...laboratoryNote, ...laboratory, ...scannedDoc });
      }
      setLoading(false);
    }

    loadTemplate();
  }, [mysqlId, setLoading, sdId, model]);

  const onClickViewIcon = () => {
    setLoading(true);
    getFile(fileName, model)
      .then((value) => {
        //Visualizamos la el fichero cargado

        setSelectedImg(URL.createObjectURL(value.data));
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        setError({
          status: error.response ? error.response.status : 502,
          errorType: 'LOAD_FILE_ERROR',
        });
      });
  };

  const onClickCamViewIcon = () => {
    if (camFileName) {
      setLoading(true);

      getFile(camFileName, 'delivery')
        .then((value) => {
          setCamImage(URL.createObjectURL(value.data));
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);

          setError({
            status: error.response ? error.response.status : 502,
            errorType: 'LOAD_FILE_ERROR',
          });
        });
    }
  };

  const onCancelViewImg = () => {
    setCamImage(null);
    setSelectedImg(null);
  };

  if (initialData) {
    return (
      <>
        {selectedCamImage && (
          <ViewImage
            img={selectedCamImage}
            visible={Boolean(selectedCamImage)}
            onCancel={onCancelViewImg}
          />
        )}
        {selectedImg && (
          <ViewImage
            img={selectedImg}
            visible={Boolean(selectedImg)}
            onCancel={onCancelViewImg}
          />
        )}
        {model === 'laboratory' ? (
          <AccionaTableLaboratory
            formState={initialData}
            viewAction={onClickCamViewIcon}
            viewLabAction={onClickViewIcon}
            labFileName={camFileName}
            deliveryFileName={fileName}
            paramsUrl={paramsUrl}
            workCode={project.work_code}
          />
        ) : (
          <AccionaTableDelivery
            formState={initialData}
            viewAction={onClickViewIcon}
            camViewAction={onClickCamViewIcon}
            camFileName={camFileName}
            fileName={fileName}
            workCode={project.work_code}
          />
        )}
      </>
    );
  } else return null;
};

export default injectIntl(DataDoc);
